import { AttributeValueContentType } from "./AttributeValueContentType";
import { ValueContentAttributeName, ValueContentDebug, ValueContentDescription, ValueContentEmpty, ValueContentHelp, ValueContentItemNo, ValueContentName, ValueContentPrice, ValueContentQuantity, ValueContentSuggestion, ValueContentTypeCode, ValueContentValue, } from "./ValueContent";
import { ValueContentImage } from "./ValueContentImage";
import { ValueContentMultiple } from "./ValueContentMultiple";
import { ValuePropertyText } from "./ValuePropertyText";
export const AttributeValueContentComponents = {
    [AttributeValueContentType.Debug]: ValueContentDebug,
    [AttributeValueContentType.Value]: ValueContentValue,
    [AttributeValueContentType.Name]: ValueContentName,
    [AttributeValueContentType.Description]: ValueContentDescription,
    [AttributeValueContentType.PropertyText]: ValuePropertyText,
    [AttributeValueContentType.AttributeName]: ValueContentAttributeName,
    [AttributeValueContentType.Image]: ValueContentImage,
    [AttributeValueContentType.TypeCode]: ValueContentTypeCode,
    [AttributeValueContentType.Help]: ValueContentHelp,
    [AttributeValueContentType.Price]: ValueContentPrice,
    [AttributeValueContentType.ItemNo]: ValueContentItemNo,
    [AttributeValueContentType.Quantity]: ValueContentQuantity,
    [AttributeValueContentType.Suggestion]: ValueContentSuggestion,
    [AttributeValueContentType.Unknown]: ValueContentEmpty,
    [AttributeValueContentType.Content]: ValueContentEmpty,
    [AttributeValueContentType.Actions]: ValueContentEmpty,
    [AttributeValueContentType.Multiple]: ValueContentMultiple,
};
//# sourceMappingURL=AttributeValueContentComponents.js.map